export class MerchantTenantExportDto {
    statuses?: string[]
    startDate?: Date
    endDate?: Date
    timezone?: string
    email?: string
}

export class MerchantVoucherExportDto extends MerchantTenantExportDto {
    
}
